export class Validators {
  static email(value) {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    return pattern.test(value) || 'Please enter a valid email address.';
  }

  static required(value) {
    return !!value;
  }

  static path(value) {
    const pattern = /^([a-z1-9-]*)$/

    return pattern.test(value) || 'You can only use lowercase letters and hyphens.'
  }

  static lettersOnly(value) {
    return /^([a-z]*)$/.test(value) || 'You can only use lowercase letters.'
  }
}
